import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

export function CollapsibleCard({
  title,
  subtitle,
  icon: Icon,
  badge,
  defaultOpen = false,
  actions,
  alert,
  children,
  empty,
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="card" style={alert ? { borderColor: 'var(--c-warning)', borderWidth: 2 } : undefined}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          width: '100%',
          textAlign: 'left',
          background: 'transparent',
          border: 'none',
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          cursor: 'pointer',
          borderBottom: open ? '1px solid var(--c-border)' : 'none',
        }}
      >
        {open ? <ChevronDown size={16} color="var(--c-text-muted)" /> : <ChevronRight size={16} color="var(--c-text-muted)" />}
        {Icon && <Icon size={15} color={alert ? 'var(--c-warning)' : 'var(--c-text-muted)'} />}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <strong style={{ fontSize: 14 }}>{title}</strong>
            {badge}
          </div>
          {subtitle && <div className="text-xs muted" style={{ marginTop: 1 }}>{subtitle}</div>}
        </div>
        {actions && <div onClick={(e) => e.stopPropagation()} style={{ display: 'flex', gap: 6 }}>{actions}</div>}
      </button>
      {open && <div style={{ padding: '14px 16px' }}>{empty || children}</div>}
    </div>
  );
}

export function SectionBadge({ color = 'default', children }) {
  return (
    <span className={`badge ${color}`} style={{ fontSize: 10, padding: '1px 8px' }}>
      {children}
    </span>
  );
}
